<template>
  <div class="work-process-area-two pt-100 pb-70">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7">
          <div class="row justify-content-center">
            <div
              class="col-lg-6 col-sm-6"
              v-for="proces in process"
              :key="proces.id"
            >
              <div class="work-process-card-two">
                <div class="number-title">{{ proces.number }}.</div>
                <h3>{{ proces.title }}</h3>
                <p>{{ proces.shortDesc }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-5">
          <div class="work-process-right">
            <div class="section-title">
              <span class="sp-color1">Our Working Process</span>
              <h2>How Our Services Will Help You to Grow Your Business</h2>
            </div>
            <router-link
              to="/contact"
              class="default-btn btn-bg-two border-radius-50 text-center"
            >
              Get A Quote
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurWorkingProcess",
  data() {
    return {
      process: [
        {
          id: 1,
          title: "Discovery",
          shortDesc:
            "In this stage, we delve deep into understanding the client's needs and requirements, laying the foundation for the entire project.",
          number: "01",
        },
        {
          id: 2,
          title: "Planning",
          shortDesc:
            "Once we have a clear understanding, we create a comprehensive plan that outlines the scope, resources, and timeline for the project.",
          number: "02",
        },
        {
          id: 3,
          title: "Execute",
          shortDesc:
            "This is where the actual development and coding of the software solution takes place, turning plans into a functional product.",
          number: "03",
        },
        {
          id: 4,
          title: "Deliver",
          shortDesc:
            "After rigorous testing and quality assurance, the finalized software solution is delivered to the client, ready for implementation and use.",
          number: "04",
        },
      ],
    };
  },
};
</script>